import React from 'react';

import { DATA_OG, DATA_TEST, getDynamicDataOGId, getDynamicDataTestId } from '../../enums';
import { MobileMenuItem } from '../Components/MobileMenuItem';
import { SubmenuHeader } from '../Components/SubmenuHeader';

export const MobileLevelThreeMenuSection = ({ section, closeMenu }) => {
  return (
    <>
      <SubmenuHeader headerText={section.title} />
      {section.items.map((item) => {
        const dataTest = item.url
          ? getDynamicDataTestId(DATA_TEST.mobile_level_three_link, item.id)
          : getDynamicDataTestId(DATA_TEST.mobile_level_three_item, item.id);
        return (
          <MobileMenuItem
            dataTest={dataTest}
            dataOG={getDynamicDataOGId(DATA_OG.menu_item, item.label)}
            item={item}
            key={item.id}
            handleClick={() => {
              if (item.onClick) {
                item.onClick();
              }
              // Ensure the menu closes after an onClick
              // or url navigation (noticeable when url opens in new tab)
              if (item.url || item.onClick) closeMenu();
            }}
          />
        );
      })}
    </>
  );
};
